import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__index',
    path: '/',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/index.vue' /* webpackChunkName: "pages-car-index.vue" */
        )
      ),
    meta: { wideContainer: true, showOneTap: true }
  }
]
